import { z } from 'zod';
export const ListTagsQuery = z.object({
    filter: z.enum(['active', 'archived', 'all']).optional(),
});
//# sourceMappingURL=requests.js.map